import React from 'react';
import Section from '../section/section';
import ArticlePreviewCard, { IArticlePreview } from '../../../components/article-preview-card/article-preview-card';

interface IArticlesListSectionProps {
  articles: IArticlePreview[];
}

export default function ArticlesListSection({ articles }: IArticlesListSectionProps) {
  return (
    <section className="articles-list-section">
      <Section className="articles-list-section__container">
        {articles.map((article, index) => (
          <ArticlePreviewCard key={index} {...article} />
        ))}
      </Section>
    </section>
  );
}
